import axios from "axios";
import { setupAuthInterceptor } from "./setupAuthInterceptor";
import { BASE_URL_DAL } from "../constants";

const apiDal = axios.create({
	baseURL: BASE_URL_DAL,
});

setupAuthInterceptor(apiDal);

export default apiDal;
